export class UtilService {

    public static validateEmail(email: string): boolean {
        return /^(\s*([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25}\s*)+([,.](\s*([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25})+\s*)*$/i.test(email);
    }

    public static validateUrl(url: string): boolean {
        return /^(https?|s?ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test(url);
    }

    public static validateNumber(val): boolean {
        return /^(\d*\.?\d+)$/i.test(val);
    }

    public static validateDigit(val): boolean {
      return /^(\d+)$/i.test(val);
  }

    public static randomString(length: number): string {
        let chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
        let result = '';
        for (let i = length; i > 0; --i) {
            result += chars[Math.round(Math.random() * (chars.length - 1))];
        }
        return result;
    }

    public static ensureFields(model: any, modelArray: any[]): void {
        if (!modelArray[model]) {
            modelArray[model] = {};
        }
    }

    public static isDigit(event) {
        let charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 &&
            (charCode < 48 || charCode > 57) &&
            (charCode < 37 || charCode > 44) &&
            (charCode < 96 || charCode > 105)) {
            // console.debug('false');
            return false;
        } else {
            // console.debug('true');
            return true;
        }
    }

    public static isNumber(event): boolean {
        // 190 is the Decimal key code and Decimal on numpad is 110
        // 46 is the DEL key
        let allowedCharCodes = [110, 190, 46];
        let charCode = (event.which) ? event.which : event.keyCode;
        let result;
        if (!(charCode > 31 &&
            (charCode < 48 || charCode > 57) &&
            (charCode < 37 || charCode > 44) &&
            (charCode < 96 || charCode > 105)) || (allowedCharCodes.indexOf(charCode) > -1))
        {
            // Check if dot already present
            result = !((charCode == 110 || charCode == 190 ) && event.target.value.indexOf('.') > -1);
        } else {
            result = false;
        }
        // console.debug(result);
        return result;
    }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./~/angular2-template-loader!./src/app/service/util.service.ts